<forge-card class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">Outstanding Invoices by Fund</h2>

            <div class="forge-typography--subheading1" fxLayout="row" fxLayoutAlign="space-between center">
                <span>As of {{AsOfDate | date: 'M/d/yyyy'}}</span>
                <span *ngIf="isLoaded && chartHasData">
                    <span class="forge-typography--heading2">Balance:</span> {{Balance | currency}}
                </span>
            </div>
        </div>

        <forge-icon-button slot="end" class="chart-settings" (click)="openSettings()" tabindex="0" aria-haspopup="true"
                           telemetry="Chart settings" aria-label="chart settings">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </forge-toolbar>

    <div class="metadata-padding">
        <div *ngIf="isLoaded">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>

            <div [fxShow]="!chartHasData">Not enough data to display graph</div>
        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>
    </div>
</forge-card>
